// import logo from './logo.svg';
// import './App.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import HomePage from './pages/HomePage'
import LoginPage from './pages/LoginPage';
import Header from './components/Header';
import PrivateRoute from './utils/PrivateRoute'
import PrivateRoute1 from './utils/PrivateRoute1';
import { AuthProvider } from './context/AuthContext';
import RegisterPage from './pages/RegisterPage';
import EmployerCompanies from './pages/EmployerCompanies';
import EmployerCategories from './pages/EmployerCategories';
import EmployerArchived from './pages/EmployerArchived';

function App() {
  
  return (
    <div className="App">
      <Router>
        <AuthProvider>  
        {/* <Header /> */}
        <Routes> 
          <Route element={<PrivateRoute />}>
            <Route exact path='/' element={<HomePage/>}/>
          </Route> 
          <Route element={<PrivateRoute />}>
            <Route path='/companies' element={<EmployerCompanies />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path='/categories' element={<EmployerCategories />} />
          </Route>
          <Route element={<PrivateRoute />}>
            <Route path='/archived' element={<EmployerArchived />} />
          </Route>
          <Route element={<LoginPage />} path='/login' />
        </Routes>
        </AuthProvider>
      </Router>
    </div>
  );
}

export default App;
